import { z } from "zod";

export const updateVehicleEligibilityPayloadSchema = z.object({
  vin: z.string(),
  brand: z.string(),
});

export type UpdateVehicleEligibilityPayload = z.infer<
  typeof updateVehicleEligibilityPayloadSchema
>;
